// Novel utilities for generating outline and managing content
import { MODEL_MODES } from '../../constants/agentConfig'

// Story structures based on https://blog.reedsy.com/guide/story-structure/
export const STORY_STRUCTURES = {
  FREYTAG_PYRAMID: {
    id: 'freytag_pyramid',
    name: 'Freytag\'s Pyramid',
    description: 'Struktur dramatis lima bagian berdasarkan tragedi Yunani klasik',
    sections: [
      { name: 'Introduction', description: 'Pengenalan karakter dan latar, insiden pemicu' },
      { name: 'Rising Action', description: 'Protagonis mengejar tujuan, konflik meningkat' },
      { name: 'Climax', description: 'Titik tidak bisa kembali, puncak ketegangan' },
      { name: 'Falling Action', description: 'Konsekuensi dari klimaks, ketegangan menurun' },
      { name: 'Catastrophe', description: 'Protagonis mencapai titik terendah' }
    ]
  },
  HERO_JOURNEY: {
    id: 'hero_journey',
    name: 'The Hero\'s Journey',
    description: 'Perjalanan pahlawan klasik dengan transformasi karakter',
    sections: [
      { name: 'Ordinary World', description: 'Kehidupan normal protagonis sebelum petualangan' },
      { name: 'Call to Adventure', description: 'Panggilan untuk memulai petualangan' },
      { name: 'Refusal of Call', description: 'Keraguan dan penolakan awal' },
      { name: 'Meeting Mentor', description: 'Bertemu dengan mentor atau panduan' },
      { name: 'Crossing Threshold', description: 'Memasuki dunia petualangan' },
      { name: 'Tests and Trials', description: 'Menghadapi tantangan dan ujian' },
      { name: 'Revelation', description: 'Penemuan penting atau wahyu' },
      { name: 'Transformation', description: 'Perubahan karakter protagonis' },
      { name: 'Return', description: 'Kembali ke dunia asal dengan kebijaksanaan baru' }
    ]
  },
  THREE_ACT: {
    id: 'three_act',
    name: 'Three Act Structure',
    description: 'Struktur tiga babak yang paling umum digunakan',
    sections: [
      { name: 'Act I - Setup', description: 'Pengenalan karakter, latar, dan konflik utama' },
      { name: 'Plot Point 1', description: 'Peristiwa yang mengubah arah cerita' },
      { name: 'Act II - Confrontation', description: 'Pengembangan konflik dan karakter' },
      { name: 'Midpoint', description: 'Titik tengah yang mengubah dinamika cerita' },
      { name: 'Plot Point 2', description: 'Krisis yang mengarah ke klimaks' },
      { name: 'Act III - Resolution', description: 'Klimaks dan resolusi cerita' }
    ]
  },
  STORY_CIRCLE: {
    id: 'story_circle',
    name: 'Dan Harmon\'s Story Circle',
    description: 'Versi sederhana dari Hero\'s Journey dalam 8 langkah',
    sections: [
      { name: 'You (Order)', description: 'Karakter dalam zona nyaman' },
      { name: 'Need', description: 'Keinginan atau kebutuhan muncul' },
      { name: 'Go', description: 'Memasuki situasi yang tidak familiar' },
      { name: 'Search', description: 'Beradaptasi dengan lingkungan baru' },
      { name: 'Find', description: 'Menemukan apa yang dicari' },
      { name: 'Take', description: 'Membayar harga yang berat' },
      { name: 'Return', description: 'Kembali ke dunia familiar' },
      { name: 'Change', description: 'Sekarang mampu mengubah dunia' }
    ]
  },
  FICHTEAN_CURVE: {
    id: 'fichtean_curve',
    name: 'Fichtean Curve',
    description: 'Struktur dengan krisis berulang yang meningkat',
    sections: [
      { name: 'Rising Action', description: 'Serangkaian krisis yang meningkat' },
      { name: 'First Crisis', description: 'Krisis pertama yang memicu konflik' },
      { name: 'Second Crisis', description: 'Krisis kedua yang lebih intens' },
      { name: 'Third Crisis', description: 'Krisis ketiga yang semakin rumit' },
      { name: 'Climax', description: 'Puncak ketegangan dan konflik' },
      { name: 'Falling Action', description: 'Resolusi bertahap' },
      { name: 'Resolution', description: 'Penyelesaian akhir cerita' }
    ]
  },
  SAVE_THE_CAT: {
    id: 'save_the_cat',
    name: 'Save the Cat Beat Sheet',
    description: 'Struktur 15 beat untuk screenplay yang diadaptasi untuk novel',
    sections: [
      { name: 'Opening Image', description: 'Gambaran pembuka yang mewakili tema' },
      { name: 'Theme Stated', description: 'Tema cerita dinyatakan' },
      { name: 'Setup', description: 'Pengenalan dunia dan karakter' },
      { name: 'Catalyst', description: 'Peristiwa yang mengubah segalanya' },
      { name: 'Debate', description: 'Protagonis mempertimbangkan pilihan' },
      { name: 'Break into Two', description: 'Keputusan untuk bertindak' },
      { name: 'B Story', description: 'Subplot yang mendukung tema' },
      { name: 'Fun and Games', description: 'Eksplorasi premis cerita' },
      { name: 'Midpoint', description: 'Kemenangan atau kekalahan semu' },
      { name: 'Bad Guys Close In', description: 'Tekanan meningkat' },
      { name: 'All Is Lost', description: 'Titik terendah protagonis' },
      { name: 'Dark Night of Soul', description: 'Momen introspeksi mendalam' },
      { name: 'Break into Three', description: 'Solusi ditemukan' },
      { name: 'Finale', description: 'Konfrontasi akhir' },
      { name: 'Final Image', description: 'Gambaran penutup yang kontras dengan pembuka' }
    ]
  },
  SEVEN_POINT: {
    id: 'seven_point',
    name: 'Seven-Point Story Structure',
    description: 'Struktur tujuh poin yang fokus pada karakter dan plot',
    sections: [
      { name: 'Hook', description: 'Pembuka yang menarik perhatian' },
      { name: 'Plot Turn 1', description: 'Peristiwa yang memulai konflik utama' },
      { name: 'Pinch Point 1', description: 'Tekanan pertama dari antagonis' },
      { name: 'Midpoint', description: 'Perubahan besar dalam cerita' },
      { name: 'Pinch Point 2', description: 'Tekanan kedua yang lebih kuat' },
      { name: 'Plot Turn 2', description: 'Informasi yang mengubah segalanya' },
      { name: 'Resolution', description: 'Penyelesaian konflik dan cerita' }
    ]
  }
}

// Novel genres
export const NOVEL_GENRES = {
  ROMANCE: 'Romance',
  MYSTERY: 'Mystery/Thriller',
  FANTASY: 'Fantasy',
  SCIENCE_FICTION: 'Science Fiction',
  HISTORICAL: 'Historical Fiction',
  CONTEMPORARY: 'Contemporary Fiction',
  ADVENTURE: 'Adventure',
  DRAMA: 'Drama',
  HORROR: 'Horror',
  COMEDY: 'Comedy',
  YOUNG_ADULT: 'Young Adult',
  LITERARY: 'Literary Fiction'
}

// Writing styles
export const WRITING_STYLES = {
  DESCRIPTIVE: 'Deskriptif - Fokus pada detail dan gambaran vivid',
  NARRATIVE: 'Naratif - Bercerita dengan alur yang kuat',
  DIALOGUE_HEAVY: 'Dialog Intensif - Banyak percakapan antar karakter',
  INTROSPECTIVE: 'Introspektif - Fokus pada pemikiran dan perasaan karakter',
  ACTION_PACKED: 'Penuh Aksi - Tempo cepat dengan banyak kejadian',
  LITERARY: 'Sastrawi - Gaya bahasa yang artistik dan mendalam',
  CONVERSATIONAL: 'Percakapan - Gaya santai seperti bercerita pada teman'
}

// Languages
export const LANGUAGES = {
  INDONESIAN: 'id',
  ENGLISH: 'en'
}

// Generate novel outline based on query/topic and selected structure
export const generateNovelOutline = async (topic, llmService, novelConfig) => {
  const selectedStructure = STORY_STRUCTURES[novelConfig.plotStructure] || STORY_STRUCTURES.THREE_ACT
  
  // Calculate optimal word distribution to ensure 250-400 pages (62,500-100,000 words)
  const targetMinWords = 62500 // 250 pages
  const targetMaxWords = 100000 // 400 pages
  const sectionCount = selectedStructure.sections.length
  
  // Calculate words per section to meet target
  const minWordsPerSection = Math.ceil(targetMinWords / sectionCount)
  const maxWordsPerSection = Math.floor(targetMaxWords / sectionCount)
  
  // Ensure each section has at least 8000 words and at most 15000 words
  const adjustedMinWords = Math.max(8000, minWordsPerSection)
  const adjustedMaxWords = Math.min(15000, maxWordsPerSection)
  
  // Ensure minimum 7 chapters for any structure
  const minRequiredSections = Math.max(7, selectedStructure.sections.length)
  const actualSections = selectedStructure.sections.length < 7 
    ? [...selectedStructure.sections, ...Array(7 - selectedStructure.sections.length).fill(null).map((_, i) => ({
        name: `Bagian ${selectedStructure.sections.length + i + 1}`,
        description: 'Pengembangan cerita lebih lanjut'
      }))]
    : selectedStructure.sections

  const prompt = `Anda adalah penulis novel profesional. Buat outline detail untuk novel berjudul "${topic}" dengan spesifikasi berikut:

**PENTING: WAJIB BUAT MINIMAL 7 BAGIAN/BAB!**

**Konfigurasi Novel:**
- Struktur Plot: ${selectedStructure.name} - ${selectedStructure.description}
- Genre: ${novelConfig.genre}
- Gaya Penulisan: ${novelConfig.writingStyle}
- Bahasa: ${novelConfig.language === 'id' ? 'Indonesia' : 'English'}
- Target: 250-400 halaman (62,500-100,000 kata)

**Struktur yang Harus Diikuti (MINIMAL ${minRequiredSections} BAGIAN):**
${actualSections.map((section, index) => 
  `${index + 1}. ${section.name}: ${section.description}`
).join('\n')}

**ATURAN WAJIB:**
- HARUS membuat TEPAT ${minRequiredSections} bagian/bab (tidak boleh kurang!)
- Jika struktur asli kurang dari 7 bagian, tambahkan bagian pengembangan cerita
- Setiap bagian harus ${adjustedMinWords.toLocaleString()}-${adjustedMaxWords.toLocaleString()} kata
- Berikan deskripsi detail untuk setiap bagian
- Pastikan alur cerita koheren dan menarik
- Kembangkan karakter utama dan pendukung
- Sertakan elemen kejutan dan twist
- Pastikan sesuai dengan genre yang dipilih

**Format Output (JSON) - WAJIB ${minRequiredSections} OBJEK:**
\`\`\`json
[
  {
    "id": "bagian_1",
    "title": "Judul Bagian 1",
    "description": "Deskripsi detail apa yang terjadi di bagian ini",
    "minWords": ${adjustedMinWords},
    "maxWords": ${adjustedMaxWords},
    "keyEvents": ["Event 1", "Event 2"],
    "characters": ["Karakter yang muncul"],
    "plotPoints": "Poin plot penting"
  },
  {
    "id": "bagian_2",
    "title": "Judul Bagian 2",
    "description": "Deskripsi detail bagian kedua",
    "minWords": ${adjustedMinWords},
    "maxWords": ${adjustedMaxWords},
    "keyEvents": ["Event 1", "Event 2"],
    "characters": ["Karakter yang muncul"],
    "plotPoints": "Poin plot penting"
  }
  // ... lanjutkan sampai bagian ke-${minRequiredSections}
]
\`\`\`

**PERINGATAN: Jika Anda tidak membuat ${minRequiredSections} bagian, outline akan ditolak!**

Buat outline yang menarik dan berkualitas tinggi dengan TEPAT ${minRequiredSections} bagian:`

  try {
    const messages = [
      {
        role: 'user',
        content: prompt
      }
    ]
    
    const response = await llmService.sendMessage(messages, {
      mode: MODEL_MODES.GENIUS,
      additionalParams: {
        max_tokens: 3000,
        temperature: 0.7
      }
    })
    
    let content = response
    
    // Multiple attempts to extract JSON from response
    let jsonContent = null
    
    // Method 1: Extract from code blocks
    const jsonMatch = content.match(/```json\s*([\s\S]*?)\s*```/)
    if (jsonMatch) {
      jsonContent = jsonMatch[1]
    } else {
      // Method 2: Look for array pattern
      const arrayMatch = content.match(/\[\s*\{[\s\S]*\}\s*\]/)
      if (arrayMatch) {
        jsonContent = arrayMatch[0]
      } else {
        // Method 3: Extract everything between first [ and last ]
        const startIndex = content.indexOf('[')
        const endIndex = content.lastIndexOf(']')
        if (startIndex !== -1 && endIndex !== -1 && endIndex > startIndex) {
          jsonContent = content.substring(startIndex, endIndex + 1)
        }
      }
    }
    
    if (jsonContent) {
      // Enhanced JSON cleaning and validation
      jsonContent = jsonContent
        .replace(/^```json\s*/, '')
        .replace(/\s*```$/, '')
        .replace(/^```\s*/, '') // Remove any remaining code block markers
        .replace(/\s*```$/, '')
        .replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7F-\x9F]/g, '') // Remove control characters but keep \t, \n, \r
        .replace(/\\n/g, '\n') // Fix escaped newlines
        .replace(/\\t/g, '\t') // Fix escaped tabs
        .replace(/\\r/g, '\r') // Fix escaped carriage returns
        .replace(/\n\s*\n/g, '\n') // Remove extra newlines
        .replace(/,\s*([\]\}])/g, '$1') // Remove trailing commas before ] or }
        .replace(/([^,\]\}])\s*$/gm, '$1') // Ensure proper line endings
        .trim()
      
      // Additional validation: ensure JSON starts with [ and ends with ]
      if (!jsonContent.startsWith('[')) {
        const startIndex = jsonContent.indexOf('[')
        if (startIndex !== -1) {
          jsonContent = jsonContent.substring(startIndex)
        }
      }
      
      if (!jsonContent.endsWith(']')) {
        const endIndex = jsonContent.lastIndexOf(']')
        if (endIndex !== -1) {
          jsonContent = jsonContent.substring(0, endIndex + 1)
        }
      }
      
      try {
        const outline = JSON.parse(jsonContent)
        
        // Validate and enhance outline
        if (Array.isArray(outline) && outline.length > 0) {
          // Validate outline structure with strict type checking
          let validatedOutline = outline.map((section, index) => {
            if (typeof section !== 'object' || section === null) {
              throw new Error(`Invalid section at index ${index}: not an object`)
            }
            return {
              id: section.id || `bagian_${index + 1}`,
              title: section.title || `Bagian ${index + 1}`,
              description: section.description || 'Deskripsi bagian',
              minWords: Number(section.minWords) || adjustedMinWords,
              maxWords: Number(section.maxWords) || adjustedMaxWords,
              keyEvents: Array.isArray(section.keyEvents) ? section.keyEvents : [],
              characters: Array.isArray(section.characters) ? section.characters : [],
              plotPoints: section.plotPoints || ''
            }
          })
          
          // Enforce minimum 7 sections
          if (validatedOutline.length < 7) {
            console.warn(`Outline only has ${validatedOutline.length} sections, expanding to 7 minimum`)
            const additionalSections = 7 - validatedOutline.length
            for (let i = 0; i < additionalSections; i++) {
              const sectionIndex = validatedOutline.length + i + 1
              validatedOutline.push({
                id: `bagian_${sectionIndex}`,
                title: `Bagian ${sectionIndex}`,
                description: `Pengembangan cerita lebih lanjut untuk novel "${topic}". Bagian ini akan melanjutkan alur cerita dengan detail yang mendalam.`,
                minWords: adjustedMinWords,
                maxWords: adjustedMaxWords,
                keyEvents: [],
                characters: [],
                plotPoints: 'Pengembangan plot dan karakter'
              })
            }
          }
          
          console.log(`Successfully parsed and validated JSON outline with ${validatedOutline.length} sections`)
          return validatedOutline
        }
      } catch (parseError) {
        console.error('Error parsing JSON outline:', parseError)
        console.log('Raw response:', response)
        console.log('Extracted JSON content:', jsonContent)
        console.log('Raw JSON content length:', jsonContent.length)
        console.log('JSON content preview:', jsonContent.substring(0, 200) + '...')
        // Try to fix common JSON issues with enhanced strategies
        let fixedJson = jsonContent
        try {
          // Strategy 1: Enhanced JSON cleaning and structure fixing
          fixedJson = jsonContent
            // Remove problematic control characters but preserve essential whitespace
            .replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7F-\x9F]/g, '')
            // Fix common escape sequence issues
            .replace(/\\n/g, '\\n')
            .replace(/\\r/g, '\\r')
            .replace(/\\t/g, '\\t')
            .replace(/\\b/g, '\\b')
            .replace(/\\f/g, '\\f')
            .replace(/\\\\/g, '\\/')
            // Remove invalid escape sequences
            .replace(/\\[^"\\\//bfnrt]/g, '')
            // Fix unterminated strings at end of lines
            .replace(/"([^"\n]*?)$/gm, '"$1"')
            // Fix missing quotes around property names
            .replace(/(\{|,)\s*([a-zA-Z_][a-zA-Z0-9_]*)\s*:/g, '$1"$2":')
            // Remove trailing commas
            .replace(/,\s*([\]\}])/g, '$1')
            // Fix missing commas between objects/arrays
            .replace(/(\}|\])\s*([\{\[])/g, '$1,$2')
            // Ensure proper structure
            .replace(/([^,\]\}])\s*$/gm, '$1')
            // Fix incomplete JSON by ensuring proper closing
            .replace(/([^\]\}])\s*$/, '$1]')
            // Fix broken string values
            .replace(/"([^"]*?)\n([^"]*?)"/g, '"$1 $2"')
            // Ensure array structure is maintained
            .replace(/^\s*\{/, '[')
            .replace(/\}\s*$/, '}]')
          
          const fixedOutline = JSON.parse(fixedJson)
          if (Array.isArray(fixedOutline) && fixedOutline.length > 0) {
            return fixedOutline.map((section, index) => ({
              id: section.id || `bagian_${index + 1}`,
              title: section.title || `Bagian ${index + 1}`,
              description: section.description || 'Deskripsi bagian',
              minWords: section.minWords || adjustedMinWords,
              maxWords: section.maxWords || adjustedMaxWords,
              keyEvents: section.keyEvents || [],
              characters: section.characters || [],
              plotPoints: section.plotPoints || ''
            }))
          }
        } catch (fixError) {
          console.error('Failed to fix JSON:', fixError)
          console.log('Fixed JSON content:', fixedJson)
          
          // Strategy 2: More aggressive cleaning with pattern reconstruction
          try {
            let aggressiveClean = jsonContent
              // Remove all non-printable characters except basic whitespace
              .replace(/[^\x20-\x7E\x09\x0A\x0D]/g, '')
              // Fix broken JSON structure patterns
              .replace(/(["\}\]])\s*(["\{\[])/g, '$1,$2')
              .replace(/,\s*([\]\}])/g, '$1')
              .replace(/([^,\]\}])\s*$/gm, '$1')
              // Try to reconstruct broken array structure
              .replace(/^[^\[]*\{/, '[')
              .replace(/\}[^\]]*$/, '}]')
              // Fix incomplete objects
              .replace(/\{[^\}]*$/, '{}]')
              // Ensure minimum valid JSON structure
              .replace(/^[^\[\{]*/, '[')
              .replace(/[^\]\}]*$/, ']')
            
            const aggressiveOutline = JSON.parse(aggressiveClean)
            if (Array.isArray(aggressiveOutline) && aggressiveOutline.length > 0) {
              return aggressiveOutline.map((section, index) => ({
                id: section.id || `bagian_${index + 1}`,
                title: section.title || `Bagian ${index + 1}`,
                description: section.description || 'Deskripsi bagian',
                minWords: section.minWords || adjustedMinWords,
                maxWords: section.maxWords || adjustedMaxWords,
                keyEvents: section.keyEvents || [],
                characters: section.characters || [],
                plotPoints: section.plotPoints || ''
              }))
            }
          } catch (aggressiveError) {
            console.error('Aggressive JSON fix also failed:', aggressiveError)
            
            // Strategy 3: Last resort - try to extract any valid JSON objects
            try {
              const objectMatches = jsonContent.match(/\{[^\{\}]*\}/g)
              if (objectMatches && objectMatches.length > 0) {
                const reconstructedArray = '[' + objectMatches.join(',') + ']'
                const lastResortOutline = JSON.parse(reconstructedArray)
                if (Array.isArray(lastResortOutline) && lastResortOutline.length > 0) {
                  console.log('Successfully reconstructed JSON from object matches')
                  return lastResortOutline.map((section, index) => ({
                    id: section.id || `bagian_${index + 1}`,
                    title: section.title || `Bagian ${index + 1}`,
                    description: section.description || 'Deskripsi bagian',
                    minWords: section.minWords || adjustedMinWords,
                    maxWords: section.maxWords || adjustedMaxWords,
                    keyEvents: section.keyEvents || [],
                    characters: section.characters || [],
                    plotPoints: section.plotPoints || ''
                  }))
                }
              }
            } catch (lastResortError) {
              console.error('Last resort JSON reconstruction failed:', lastResortError)
            }
          }
        }
        
        // Final fallback: create basic outline
        console.warn('All JSON parsing strategies failed, using fallback outline')
        return createFallbackOutline(selectedStructure, topic, adjustedMinWords, adjustedMaxWords)
      }
    }
    
    // If all else fails, create fallback outline
    return createFallbackOutline(selectedStructure, topic, adjustedMinWords, adjustedMaxWords)
    
  } catch (error) {
    console.error('Error generating novel outline:', error)
    // Return fallback outline instead of throwing error
    const targetMinWords = 62500
    const targetMaxWords = 100000
    const sectionCount = selectedStructure.sections.length
    const minWordsPerSection = Math.ceil(targetMinWords / sectionCount)
    const maxWordsPerSection = Math.floor(targetMaxWords / sectionCount)
    const adjustedMinWords = Math.max(8000, minWordsPerSection)
    const adjustedMaxWords = Math.min(15000, maxWordsPerSection)
    
    return createFallbackOutline(selectedStructure, topic, adjustedMinWords, adjustedMaxWords)
  }
}

// Create fallback outline if LLM fails
const createFallbackOutline = (structure, topic, minWords = null, maxWords = null) => {
  // Calculate optimal word distribution if not provided
  if (!minWords || !maxWords) {
    const targetMinWords = 62500 // 250 pages
    const targetMaxWords = 100000 // 400 pages
    const sectionCount = structure.sections.length
    
    const minWordsPerSection = Math.ceil(targetMinWords / sectionCount)
    const maxWordsPerSection = Math.floor(targetMaxWords / sectionCount)
    
    minWords = Math.max(8000, minWordsPerSection)
    maxWords = Math.min(15000, maxWordsPerSection)
  }
  
  // Ensure minimum 7 sections for fallback
  const minRequiredSections = Math.max(7, structure.sections.length)
  const actualSections = structure.sections.length < 7 
    ? [...structure.sections, ...Array(7 - structure.sections.length).fill(null).map((_, i) => ({
        name: `Bagian ${structure.sections.length + i + 1}`,
        description: 'Pengembangan cerita lebih lanjut'
      }))]
    : structure.sections
  
  const fallbackOutline = actualSections.map((section, index) => ({
    id: `bagian_${index + 1}`,
    title: `${section.name}`,
    description: `${section.description} untuk novel "${topic}". Bagian ini akan mengembangkan cerita dengan detail yang mendalam dan karakter yang kuat.`,
    minWords: minWords,
    maxWords: maxWords,
    keyEvents: [],
    characters: [],
    plotPoints: section.description
  }))
  
  console.log(`Created fallback outline with ${fallbackOutline.length} sections`)
  return fallbackOutline
}

// Validate novel outline with auto-adjustment
export const validateNovelOutline = (outline) => {
  if (!outline || !Array.isArray(outline) || outline.length === 0) {
    return {
      isValid: false,
      errors: ['Outline tidak boleh kosong'],
      chapterCount: 0,
      estimatedWords: 0,
      estimatedPages: 0,
      adjustedOutline: null
    }
  }

  const errors = []
  let totalMinWords = 0
  let totalMaxWords = 0
  let adjustedOutline = [...outline]
  let needsAdjustment = false

  // First pass: validate and calculate totals
  adjustedOutline.forEach((section, index) => {
    if (!section.title || section.title.trim() === '') {
      section.title = `Bagian ${index + 1}`
      needsAdjustment = true
    }
    if (!section.description || section.description.trim() === '') {
      section.description = `Deskripsi untuk bagian ${index + 1}`
      needsAdjustment = true
    }
    
    const minWords = section.minWords || 8000
    const maxWords = section.maxWords || 12000
    
    totalMinWords += minWords
    totalMaxWords += maxWords
  })

  const estimatedWords = Math.round((totalMinWords + totalMaxWords) / 2)
  const estimatedPages = Math.round(estimatedWords / 250) // 250 words per page

  // Auto-adjustment logic for word count
  if (estimatedPages < 250) {
    const targetMinWords = 62500 // 250 pages
    const wordsPerSection = Math.ceil(targetMinWords / adjustedOutline.length)
    
    adjustedOutline.forEach(section => {
      section.minWords = Math.max(section.minWords || 8000, wordsPerSection)
      section.maxWords = Math.max(section.maxWords || 12000, wordsPerSection + 2000)
    })
    
    needsAdjustment = true
    errors.push('Novel terlalu pendek. Kata per bagian telah disesuaikan otomatis.')
  }
  
  if (estimatedPages > 400) {
    const targetMaxWords = 100000 // 400 pages
    const wordsPerSection = Math.floor(targetMaxWords / adjustedOutline.length)
    
    adjustedOutline.forEach(section => {
      section.minWords = Math.min(section.minWords || 8000, wordsPerSection - 2000)
      section.maxWords = Math.min(section.maxWords || 12000, wordsPerSection)
    })
    
    needsAdjustment = true
    errors.push('Novel terlalu panjang. Kata per bagian telah disesuaikan otomatis.')
  }

  // Recalculate after adjustments
  if (needsAdjustment) {
    totalMinWords = 0
    totalMaxWords = 0
    adjustedOutline.forEach(section => {
      totalMinWords += section.minWords
      totalMaxWords += section.maxWords
    })
  }

  const finalEstimatedWords = Math.round((totalMinWords + totalMaxWords) / 2)
  const finalEstimatedPages = Math.round(finalEstimatedWords / 250)

  return {
    isValid: finalEstimatedPages >= 250 && finalEstimatedPages <= 400,
    errors: finalEstimatedPages >= 250 && finalEstimatedPages <= 400 ? [] : errors,
    chapterCount: adjustedOutline.length,
    estimatedWords: finalEstimatedWords,
    estimatedPages: finalEstimatedPages,
    wordRange: `${totalMinWords.toLocaleString()}-${totalMaxWords.toLocaleString()}`,
    adjustedOutline: needsAdjustment ? adjustedOutline : null
  }
}

// Auto-fix outline to ensure it meets validation requirements
export const autoFixOutline = (outline) => {
  if (!outline || !Array.isArray(outline) || outline.length === 0) {
    return outline
  }

  const validation = validateNovelOutline(outline)
  
  // If validation passed or we have an adjusted outline, use it
  if (validation.isValid || validation.adjustedOutline) {
    return validation.adjustedOutline || outline
  }

  // Additional fixes if needed
  const fixedOutline = outline.map((section, index) => ({
    ...section,
    id: section.id || `bagian_${index + 1}`,
    title: section.title || `Bagian ${index + 1}`,
    description: section.description || `Deskripsi untuk bagian ${index + 1}`,
    minWords: section.minWords || 10000,
    maxWords: section.maxWords || 13000,
    keyEvents: section.keyEvents || [],
    characters: section.characters || [],
    plotPoints: section.plotPoints || ''
  }))

  return fixedOutline
}

// Calculate total words from outline
export const calculateTotalWords = (outline) => {
  if (!outline || !Array.isArray(outline)) return 0
  
  return outline.reduce((total, section) => {
    const minWords = section.minWords || 8000
    const maxWords = section.maxWords || 12000
    return total + Math.round((minWords + maxWords) / 2)
  }, 0)
}

// Count words in text content
export const countWords = (text) => {
  if (!text || typeof text !== 'string') return 0
  return text.trim().split(/\s+/).filter(word => word.length > 0).length
}

// Alias for compatibility
export const calculateWordCount = countWords

// Format progress percentage
export const formatProgress = (current, total) => {
  if (total === 0) return 0
  return Math.round((current / total) * 100)
}

// Estimate time remaining for novel generation
export const estimateTimeRemaining = (current, total, startTime) => {
  if (!startTime || current === 0 || total === 0 || current >= total) return null
  
  const elapsed = Date.now() - startTime
  if (elapsed <= 0) return null
  
  const avgTimePerSection = elapsed / current
  const remaining = (total - current) * avgTimePerSection
  
  const minutes = Math.ceil(remaining / (1000 * 60))
  
  if (minutes < 1) return 'Kurang dari 1 menit'
  if (minutes === 1) return '1 menit'
  if (minutes < 60) return `${minutes} menit`
  
  const hours = Math.floor(minutes / 60)
  const remainingMinutes = minutes % 60
  
  if (hours === 1 && remainingMinutes === 0) return '1 jam'
  if (hours === 1) return `1 jam ${remainingMinutes} menit`
  if (remainingMinutes === 0) return `${hours} jam`
  
  return `${hours} jam ${remainingMinutes} menit`
}

// Alias for compatibility
export const estimateRemainingTime = estimateTimeRemaining

// Generate novel metadata
export const generateNovelMetadata = (topic, outline, novelConfig) => {
  const totalWords = calculateTotalWords(outline)
  const estimatedPages = Math.ceil(totalWords / 250) // Assuming 250 words per page
  
  return {
    title: topic,
    totalWords: totalWords,
    estimatedPages: estimatedPages,
    chapterCount: outline.length,
    language: novelConfig.language,
    genre: novelConfig.genre,
    plotStructure: novelConfig.plotStructure,
    writingStyle: novelConfig.writingStyle,
    generatedAt: new Date().toISOString(),
    wordTarget: '62,500-100,000 kata',
    pageTarget: '250-400 halaman'
  }
}

// Parse markdown content and extract citations
export const parseMarkdownContent = (content) => {
  if (!content) return { parsedContent: '', citations: [], preview: '', hasMore: false }
  
  // Extract citations from content (various formats)
  const citationRegex = /\(([^)]+,\s*\d{4}[a-z]?)\)|\[([^\]]+)\]/g
  const citations = []
  let match
  
  while ((match = citationRegex.exec(content)) !== null) {
    citations.push(match[1] || match[2])
  }
  
  // Remove duplicate citations
  const uniqueCitations = [...new Set(citations)]
  
  // Clean and format content for UI display
  let cleanedContent = content
  
  // Remove common LLM artifacts for UI display
  const llmPatterns = [
    // Remove meta-commentary about the story
    /^(Tentu,?\s*)?(Berikut|Ini adalah|Dalam|Pada|Cerita ini|Novel ini|Kisah ini|Sekarang|Kali ini).*?[.:]/gmi,
    /^(Tentu,?\s*)?(Here is|This is|The story|In this|Now|This time).*?[.:]/gmi,
    /^(Tentu,?\s*)?(ini adalah|this is)\s+(Act|Bab|Chapter|Bagian).*?untuk novel.*?[.:]/gmi,
    
    // Remove instructional phrases
    /^(Mari kita|Let's|Now let's|Sekarang mari|Ayo kita|Come on).*?[.:]/gmi,
    /^(Kita akan|We will|I will now|Saya akan|I'll).*?[.:]/gmi,
    
    // Remove transitional meta-text
    /^(Selanjutnya|Next|Kemudian|Then|Lalu|Setelah itu).*?(cerita|story|bagian|part).*?[.:]/gmi,
    /^(Bagian ini|This part|This section|Pada bagian ini|In this section).*?[.:]/gmi,
    
    // Remove chapter/section announcements
    /^(Chapter|Bab|Bagian|Part)\s*\d+\s*[:-]?\s*/gmi,
    /^(Chapter|Bab|Bagian|Part)\s*[A-Z][a-z]*\s*[:-]?\s*/gmi,
    
    // Remove Roman numerals and numbering at end
    /\s*[IVX]+\.?\s*$/gmi,
    /\s*\d+\.?\s*$/gm,
    
    // Remove redundant spacing
    /\n\s*\n\s*\n+/g
  ]
  
  // Apply cleaning patterns
  llmPatterns.forEach(pattern => {
    if (pattern.source.includes('\\n')) {
      cleanedContent = cleanedContent.replace(pattern, '\n\n')
    } else {
      cleanedContent = cleanedContent.replace(pattern, '')
    }
  })
  
  // Split into paragraphs and format for better readability
  const paragraphs = cleanedContent.split(/\n\s*\n/).filter(para => {
    const trimmed = para.trim()
    // Keep substantial paragraphs or dialogue
    return trimmed.length > 30 || trimmed.match(/^["'].*["']$/) || trimmed.match(/^[A-Z][a-z]+:/)
  })
  
  // Format paragraphs with proper spacing for UI
  const formattedParagraphs = paragraphs.map(para => {
    let formatted = para.trim()
    
    // Handle dialogue with special formatting
    if (formatted.match(/^["'].*["']$/)) {
      return `    ${formatted}` // Indent dialogue
    }
    
    // Handle character names or scene headers
    if (formatted.match(/^[A-Z][a-z]+\s*:/)) {
      return `\n${formatted}\n` // Add spacing around character names
    }
    
    return formatted
  })
  
  const processedContent = formattedParagraphs.join('\n\n')
  
  // Create preview (first 300 characters with complete sentences)
  let preview = processedContent
  const hasMore = processedContent.length > 300
  
  if (hasMore) {
    preview = processedContent.substring(0, 300)
    // Find the last complete sentence
    const lastSentenceEnd = Math.max(
      preview.lastIndexOf('.'),
      preview.lastIndexOf('!'),
      preview.lastIndexOf('?')
    )
    
    if (lastSentenceEnd > 100) {
      preview = preview.substring(0, lastSentenceEnd + 1)
    }
    
    preview += '...'
  }
  
  return {
    parsedContent: processedContent,
    citations: uniqueCitations,
    preview: preview,
    hasMore: hasMore
  }
}